import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'formly-panel-wrapper',
  template: `
    <div class="panel panel-default">
      @if (props.label) {
        <div class="panel-heading">
          <span class="gea-font-heading-24">{{ props.label }}</span>
        </div>
      }
      <ng-container #fieldComponent></ng-container>
    </div>
  `,
  styles: [
    `
      .panel-heading {
        padding: 0 0 1.25rem 0;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelWrapperComponent extends FieldWrapper {}
